import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import {
  useGetVendorDataDetailQuery,
  useUpdateVendorDataMutation,
} from "store/services/CanUsers/vendorApi";
import VendorForm from "./vendorComponents/VendorForm";

const VendorEditScreen = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Vendor",
      path: "/app/crm/vendor/list",
    },
    {
      title: "Edit Vendor",
    },
  ];

  // RTK Query
  const { data: vendorDetail, isLoading: loadingDetail } =
    useGetVendorDataDetailQuery(id);

  const [updateVendor, { isLoading: updateVendorDetail }] =
    useUpdateVendorDataMutation();

  // method
  const handleVendorUpdate = async (data) => {
    try {
      await updateVendor({ ...data, _id: id }).unwrap();
      navigate(`/app/crm/vendor/${id}/detail`);
      toast.success("Vendor successfully updated!");
    } catch (error) {
      toast.error(
        error?.data?.message ?? error?.message ?? "Couldn't update vendor"
      );
    }
  };

  useAppMeta("Edit Vendor");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDetail || updateVendorDetail}
    >
      <BreadcrumbLayout.Paper>
        <VendorForm
          vendorDetail={vendorDetail}
          isBusy={loadingDetail || updateVendorDetail}
          onSubmit={handleVendorUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorEditScreen;
